import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { SharedModule } from "#modules/shared/shared.module";

export enum ExpandArrowState {
  Closed = "closed",
  Loading = "loading",
  Expanded = "expanded",
  Disabled = "disabled",
  Hidden = "hidden",
}

@Component({
  selector: "app-expand-arrow",
  templateUrl: "./expand-arrow.component.html",
  styleUrls: ["./expand-arrow.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, MatProgressSpinnerModule],
  host: {
    "[style.font-size]": "fontSize()",
  },
})
export class ExpandArrowComponent {
  readonly ExpandArrowState = ExpandArrowState;

  readonly state = input.required<ExpandArrowState | null>();

  readonly fontSize = computed(() => toPx(this.size()));

  readonly size = input<number>(24);

  readonly diameter = computed(() => this.size() * 0.75);

  readonly gap = computed(() => toPx((this.size() - this.diameter()) / 2));

  readonly isExpanded = computed(() => this.state() === ExpandArrowState.Expanded);
}

function toPx(n: number) {
  return n != null && typeof n === "number" ? `${n.toFixed(0)}px` : null;
}
